// Onglets collections (pastilles) — sections/featured-collection.liquid
if (!customElements.get('collection-tabs')) {
  customElements.define('collection-tabs', class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
      });
    }

    select(tab) {
      this.tabs.forEach((other) => {
        const selected = other === tab;
        other.setAttribute('aria-selected', selected);
        other.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(other.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });

      tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });

      const section = this.closest('[data-section-type]');
      const link = section && section.querySelector('[data-collection-tabs-link]');
      if (link && tab.dataset.collectionUrl) link.href = tab.dataset.collectionUrl;
    }

    onKeydown(event, tab) {
      const index = this.tabs.indexOf(tab);
      let next;
      if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
      if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
      if (!next) return;
      event.preventDefault();
      next.focus();
      this.select(next);
    }
  });
}
